import React, { useState } from 'react';
import axios from 'axios';
import {
  Box, Paper, Typography, TextField, Button, Alert,
} from '@mui/material';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

const API = (process.env.REACT_APP_API_URL || 'https://hr.adityatrading.in/').replace(/\/$/, '');

export default function SuperAdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await axios.post(`${API}/superadmin/login/`, { username, password });
      localStorage.setItem('superadmin_token', res.data.token);
      localStorage.setItem('superadmin_user', res.data.username);
      window.location.href = '/superadmin/dashboard';
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2,
    }}>
      <Paper elevation={16} sx={{ p: 5, maxWidth: 420, width: '100%', borderRadius: 4 }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <AdminPanelSettingsIcon sx={{ fontSize: 48, color: '#1976d2', mb: 1 }} />
          <Typography variant="h5" sx={{ fontWeight: 800, color: '#1e293b' }}>
            Super Admin
          </Typography>
          <Typography variant="body2" sx={{ color: '#64748b' }}>
            Platform Management Console
          </Typography>
        </Box>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth label="Username" value={username}
            onChange={(e) => setUsername(e.target.value)}
            sx={{ mb: 2 }} required autoFocus
          />
          <TextField
            fullWidth label="Password" type="password" value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={{ mb: 3 }} required
          />
          <Button
            type="submit" variant="contained" fullWidth disabled={loading}
            sx={{ py: 1.5, fontWeight: 700, fontSize: '1rem', borderRadius: 2 }}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </Button>
        </form>
      </Paper>
    </Box>
  );
}
